import { Icon, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import SimpleDialogContentCarded from './SimpleDialogContentCarded';

const DefaultHeaderComponent = ({ title, icon, toolbar, searchBar = '' }) => {
  return (
    <div className="flex flex-1 w-full items-center justify-between">
      <div className="flex items-center">
        {icon && <Icon className="text-32">{icon}</Icon>}
        {searchBar ? (
          <Typography className="sm:flex xs:flex md:flex-shrink-0 lg:flex-shrink-0 mx-10" variant="h6">
            {title}
          </Typography>
        ) : (
          <Typography className="hidden sm:flex mx-0 sm:mx-12" variant="h6">
            {title}
          </Typography>
        )}
      </div>
      {searchBar && <div className="flex items-center justify-center w-full">{searchBar}</div>}
      <div className="flex">{toolbar}</div>
    </div>
  );
};

function SimpleDialogContent({ header, contentToolbar, content, innerScroll, fullScreen, contentStyle }) {
  return (
    <SimpleDialogContentCarded
      innerScroll={innerScroll}
      fullScreen={fullScreen}
      header={
        <DefaultHeaderComponent
          title={header.title}
          icon={header.icon}
          toolbar={header.toolbar}
          searchBar={header.searchBar}
        />
      }
      contentToolbar={contentToolbar}
      content={<div style={{ padding: '16px', ...contentStyle }}>{content}</div>}
    />
  );
}

SimpleDialogContent.propTypes = {
  header: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.shape({
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      toolbar: PropTypes.node,
      searchBar: PropTypes.node,
    }),
  ]),
  contentToolbar: PropTypes.node,
  content: PropTypes.node,
  innerScroll: PropTypes.bool,
  contentStyle: PropTypes.object,
};

SimpleDialogContent.defaultProps = {
  innerScroll: true,
  contentStyle: {},
};

export default SimpleDialogContent;
